"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var reportcard_controller_1 = __importDefault(require("./reportcard.controller"));
var reportcard_directive_1 = __importDefault(require("./reportcard.directive"));
exports.default = angular_1.default
    .module("directives.reportcard", [])
    .directive("dcReportcard", reportcard_directive_1.default)
    .controller("dcReportcardController", reportcard_controller_1.default);
